import { render, staticRenderFns } from "./NoteAddModalButton.vue?vue&type=template&id=f0f36ba0&"
import script from "./NoteAddModalButton.vue?vue&type=script&lang=ts&"
export * from "./NoteAddModalButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports